<mds-datepicker
    (keyup)="writeText($event)"
    #mds_datepicker
    [label]="label"
    [hint]="hint"
    [appearance]="appearance"
    [id]="id"
    [required]="required"
    (dateChange)="emitDateChange($event)"
    [formCtrl]="localFormControl"
    [placeholder]="placeholder"
    [min]="min"
    [max]="max"
></mds-datepicker>
